import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen pt-32 pb-20 bg-gradient-to-b from-gray-50 to-white">
      {/* Page Header */}
      <section className="relative text-white py-20 mb-16" style={{
        background: 'linear-gradient(135deg, #0A2463 0%, #0D2F7E 50%, #1035A0 100%)'
      }}>
        <div className="container mx-auto px-4 text-center relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{
            textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
          }}>
            Mentions <span style={{ 
              background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Légales</span>
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed mt-6">
            Informations légales relatives à l'entreprise
          </p>
        </div>
      </section>

      {/* Content */}
      <div className="container mx-auto px-4 max-w-4xl">
        {/* Identification de l'entreprise */}
        <section className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8">
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2463' }}>
            Identification de <span style={{ 
              background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>l'Entreprise</span>
          </h2>
          
          <div className="space-y-4 text-gray-700">
            <div>
              <p className="font-semibold text-lg">Raison sociale :</p>
              <p>Chango's Renovation</p>
            </div>

            <div>
              <p className="font-semibold text-lg">Forme juridique :</p>
              <p>Besloten Vennootschap (Société Privée à Responsabilité Limitée)</p>
            </div>

            <div>
              <p className="font-semibold text-lg">Numéro d'entreprise (BCE) :</p>
              <p>1031.011.713</p>
            </div>

            <div>
              <p className="font-semibold text-lg">Numéro de TVA :</p>
              <p>BE 1031.011.713</p>
            </div>

            <div>
              <p className="font-semibold text-lg">Adresse du siège social :</p>
              <p>Brusselstraat 189<br />
              1702 Dilbeek<br />
              Belgique</p>
            </div>

            <div>
              <p className="font-semibold text-lg">Activité principale :</p>
              <p>Travaux d'installation électrique générale (NACE-BEL : 43.211)</p>
            </div>

            <div>
              <p className="font-semibold text-lg">Date de début d'activité :</p>
              <p>1er décembre 2025</p>
            </div>

            <div>
              <p className="font-semibold text-lg">Gérant :</p>
              <p>Alex Chango Vargas</p>
            </div>
          </div>
        </section>

        {/* Coordonnées de contact */}
        <section className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8">
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2463' }}>
            Coordonnées de <span style={{ 
              background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Contact</span>
          </h2>
          
          <div className="space-y-4 text-gray-700">
            <div>
              <p className="font-semibold text-lg">Téléphone :</p>
              <p><a href="tel:0471664418" className="text-brand-gold hover:underline">0471 66 44 18</a></p>
            </div>

            <div>
              <p className="font-semibold text-lg">Email :</p>
              <p><a href="mailto:changos.renovation@gmail.com" className="text-brand-gold hover:underline">changos.renovation@gmail.com</a></p>
            </div>

            <div>
              <p className="font-semibold text-lg">Site web :</p>
              <p><a href="https://changos-renovation.com" className="text-brand-gold hover:underline">https://changos-renovation.com</a></p>
            </div>
          </div>
        </section>

        {/* Hébergement */}
        <section className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8">
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2463' }}>
            <span style={{ 
              background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Hébergement</span> du Site
          </h2>
          
          <div className="space-y-4 text-gray-700">
            <div>
              <p className="font-semibold text-lg">Hébergeur :</p>
              <p>Emergent Agent<br />
              Site web : <a href="https://emergentagent.com" target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:underline">https://emergentagent.com</a></p>
            </div>
          </div>
        </section>

        {/* Propriété intellectuelle */}
        <section className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8">
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2463' }}>
            Propriété <span style={{ 
              background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Intellectuelle</span>
          </h2>
          
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p>
              L'ensemble de ce site relève de la législation belge et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
            </p>
            <p>
              La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est formellement interdite sauf autorisation expresse du directeur de la publication.
            </p>
          </div>
        </section>

        {/* Protection des données */}
        <section className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8">
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2463' }}>
            Protection des <span style={{ 
              background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Données</span>
          </h2>
          
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p>
              Conformément au Règlement Général sur la Protection des Données (RGPD) et à la législation belge sur la protection de la vie privée, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.
            </p>
            <p>
              Pour exercer ce droit, vous pouvez nous contacter par email à <a href="mailto:changos.renovation@gmail.com" className="text-brand-gold hover:underline">changos.renovation@gmail.com</a> ou par courrier à l'adresse de notre siège social.
            </p>
            <p>
              Pour plus d'informations, consultez notre <Link to="/politique-confidentialite" className="text-brand-gold hover:underline font-semibold">Politique de Confidentialité</Link>.
            </p>
          </div>
        </section>

        {/* CTA */}
        <section className="mt-12">
          <div className="rounded-2xl p-8 md:p-12 text-center" style={{
            background: 'linear-gradient(135deg, #0A2463 0%, #0D2F7E 50%, #1035A0 100%)'
          }}>
            <h2 className="text-3xl font-bold text-white mb-4">
              Une Question ?
            </h2>
            <p className="text-xl text-white/90 mb-8">
              N'hésitez pas à nous contacter pour toute information complémentaire
            </p>
            <Link 
              to="/contact" 
              className="inline-flex items-center justify-center gap-2 bg-brand-gold text-gray-900 px-8 py-4 rounded-xl font-bold text-lg hover:bg-brand-gold-light transition-all hover:shadow-xl hover:scale-105"
            >
              Nous Contacter
              <ArrowRight size={20} />
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default MentionsLegales;
